"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function reduce(arrayLike, callback, initialValue) {
    return Array.prototype.reduce.call(arrayLike, callback, initialValue);
}
exports.reduce = reduce;
function forEachMatch(string, pattern, callback) {
    var match = pattern.exec(string);
    while (match !== null) {
        callback(match);
        match = pattern.exec(string);
    }
}
exports.forEachMatch = forEachMatch;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/element-queries/utils.js
// module id = 67
// module chunks = 0